
        import OpenApp from '../../src/lib/utils/invoker';
        import { ubcLog } from '../../src/lib/log';
        import brandScheme from '../../src/lib/utils/brandScheme'
        import { systemInfo } from '../../src/lib/utils/browser';
        var btn = document.getElementById('download-btn');
        var aLink = document.getElementById('download-btn-link');
        var UA = window.navigator.userAgent.toLowerCase();
        var { isBaidu, isAndroid, isIOS, isWeixin } = systemInfo();
        var overlay = document.getElementById('overlay');
        var downloadLink = 'https://testflight.apple.com/join/' + getQuery('tf');
        var canJumpTf = getQuery('tf') !== '';
        var cfrom = getQuery('whfrom'); // 因为手百默认会添加 cfrom，这会无法下载，所以干脆不使用此数据
        var ct = getQuery('ct') || '';
        var hasCfrom = !!cfrom;
        var scheme = `baiduwanhua://newsystem/invokeApp?params=${encodeURIComponent(JSON.stringify({
            ext: '',
            from: 'new-download',
        }))}`;
        var targetUrl = `https://itunes.apple.com/cn/app/id6446882473?mt=8&ct=${ct}`;
        var openapp = new OpenApp({
            applink: `https://wakeup.baidu.com/baiduwanhua/scheme?scheme=${encodeURIComponent(scheme)}&target=${encodeURIComponent(targetUrl)}`,
            scheme,
            iosUseScheme: false,
            timeout: 2500,
            // 唤起app状态回调
            callback(status) {
                if (status === 'SUCCESS' || isIOS) {
                    return;
                }

                // 如果是安卓 (华为/小米/oppo/vivo)，直接到应用市场
                if (isAndroid) {
                    var judgeBrandScheme = brandScheme(UA);
                    if (judgeBrandScheme && !/baiduboxapp|mqqbrowser|heytapbrowser/i.test(UA)) {
                        window.location.href = judgeBrandScheme;
                        return;
                    }
                }

                // 如果是安卓，并且区分渠道号，换链接
                if (isAndroid && hasCfrom) {
                    aLink.href = `https://yiyanstatic.cdn.bcebos.com/download/${cfrom}/yiyan.apk`;
                }
                aLink.click();
            },
        });
        // 获取query参数
        function getQuery(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return '';
        }

        function getOSVersion(options) {
            var { UA, isIOS, isAndroid } = options;
            var result = 0;
            if (isAndroid) {
                var androidMatch = UA.match(/(android);?\s+([\d.]+)?/);
                // 优先判断android并且提前 return，避免 android 的仿 IOS 系统，例如'android 1.1 xxxIOS 1.0'情况被识别为 ios 系统并返回错误版本
                return androidMatch && androidMatch[2];
            }
            if (isIOS) {
                var iosMatch = UA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/);
                return iosMatch && iosMatch[2].replace(/_/g, '.');
            }
            return result;
        }

        aLink.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        // 下载按钮点击
        btn.addEventListener('click', function (e) {
            // 点击打点
            ubcLog({
                params: {
                    type: 'click',
                    value: 'button',
                    page: 'download',
                },
                ext: {
                    'os_version': getOSVersion({ UA, isIOS, isAndroid }),
                    'system': isIOS ? 'ios' : 'android',
                    'is_auto': 0,
                    'link': window.location.href,
                },
            });
            // 如果在微信中
            if (isWeixin) {
                // 安卓 或者 IOS但是可以跳转TF 展示蒙层
                // if (!isIOS || (isIOS && canJumpTf)) {
                overlay.style.display = 'block';
                e.preventDefault();
                return false;
                // }
            }

            // IOS如果直接打开页面
            if (isIOS && canJumpTf) {
                // 可以跳转TF ios跳转tf下载页
                window.location.href = downloadLink;
                e.preventDefault();
                return false;
            } else {
                openapp.open();
            }

            // 如果是安卓，并且区分渠道号，换链接
            // if (isAndroid && hasCfrom) {
            //     aLink.href = `https://yiyanstatic.cdn.bcebos.com/download/${cfrom}/yiyan.apk`;
            // }
            // aLink.click();
        });

        // 点击蒙层，蒙层消失
        overlay.addEventListener('click', function (e) {
            overlay.style.display = 'none';
        });

        window.onload = function () {
            ubcLog({
                params: {
                    type: 'display',
                    value: '',
                    page: 'newdownload',
                },
                ext: {
                    'os_version': getOSVersion({ UA, isIOS, isAndroid }),
                    'system': isIOS ? 'ios' : 'android',
                    'link': window.location.href,
                },
            });
        };
    